import { HStack, Image, Text, VStack } from '@chakra-ui/react';
import MESSE_LOGO from '../../../app/assets/koelnmesse-logo.svg';
import PARKPAY_LOGO from '../../../app/assets/park+pay-logo.svg';
import { AppTheme } from '../../theming/valuobject/app-theme.ts';
import { useLingui } from '@lingui/react/macro';
import { useNavigate } from 'react-router';

export default function PageHeader() {
  const { t } = useLingui();
  const navigate = useNavigate();

  return (
    <HStack as={'header'} bg={AppTheme.Color.white} justifyContent={'space-between'} width={'100%'}>
      <VStack
        alignItems={'start'}
        marginLeft={{
          base: AppTheme.Size.PX_28,
          md: AppTheme.Size.PX_48,
          lg: AppTheme.Size.PX_72,
          xl: AppTheme.Size.PX_192,
        }}
        marginY={{ base: AppTheme.Size.PX_20, md: AppTheme.Size.PX_32 }}
      >
        <Image
          src={MESSE_LOGO}
          width={{ base: AppTheme.Size.PX_128, md: AppTheme.Size.PX_256 }}
          alt={t`Messe Logo`}
          aria-label={t`Logo der koelnmesse`}
          onClick={() => navigate(`/`)}
          onKeyDown={(event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              navigate(`/`);
            }
          }}
          tabIndex={0}
          cursor={'pointer'}
        />
      </VStack>
      <VStack
        alignItems={'end'}
        gap={0.5}
        marginRight={{
          base: AppTheme.Size.PX_28,
          md: AppTheme.Size.PX_48,
          lg: AppTheme.Size.PX_72,
          xl: AppTheme.Size.PX_192,
        }}
        marginY={{ base: AppTheme.Size.PX_20, md: AppTheme.Size.PX_32 }}
      >
        <Image
          src={PARKPAY_LOGO}
          width={{ base: AppTheme.Size.PX_112, md: AppTheme.Size.PX_208 }}
          alt={t`ParkPay Logo`}
          aria-label={t`Logo für Park+Pay`}
        />
        <Text
          fontSize={{ base: AppTheme.Size.PX_24, md: AppTheme.Size.PX_44 }}
          fontWeight={AppTheme.FontWeight.WEIGHT_500}
          color={AppTheme.Color.darkgray}
        >
          {t`PARKEN EINFACH ONLINE ZAHLEN`}
        </Text>
      </VStack>
    </HStack>
  );
}
